<div class="animation-wrapper">
  <img id="{{id}}" src="assets/img/Logo_point_pay.png" alt="" />
</div>

